import qs from 'qs'

export default {
  mappedData: items => {
    const result = {}

    for (let key in items) {
      if (items.hasOwnProperty(key) && items[key].length) {
        if (Array.isArray(items[key])) {
          result[key] = items[key].join(',')
        } else {
          result[key] = items[key]
        }
      }
    }

    return result
  },
  stringifyData: items => {
    const arr = []

    for (let key in items) {
      if (items.hasOwnProperty(key) && items[key].length) {
        if (Array.isArray(items[key])) {
          arr.push(`${key}=${items[key].join(',')}`)
        } else {
          arr.push(`${key}=${items[key]}`)
        }
      }
    }

    return arr.filter(Boolean).length !== 0 ? `${arr.filter(Boolean).join('&')}` : ''
  },
  parseData: searchParams => {
    const parsedUrl = qs.parse(searchParams.substr(1))
    const items = {}

    for (let key in parsedUrl) {
      if (parsedUrl.hasOwnProperty(key)) {
        if (parsedUrl[key].includes(',')) {
          items[key] = parsedUrl[key].split(',')
        } else {
          items[key] = parsedUrl[key]
        }
      }
    }

    return items
  }
}
